/* eslint-disable @typescript-eslint/no-explicit-any */
import { DefaultTFuncReturn } from 'i18next';
import { useId } from 'react';
import { FieldValues, Path, UnPackAsyncDefaultValues, UseFormRegister } from 'react-hook-form';


interface CheckBoxProps<T extends FieldValues> {
  name: Path<UnPackAsyncDefaultValues<T>>;
  label?: DefaultTFuncReturn | undefined;
  labelBefore?: string | undefined;
  isDisabled?: boolean | undefined;
  value?: string | number | readonly string[] | undefined;
  parentSpanClassName?: string | undefined;
  register: UseFormRegister<T>;
}

export function CheckBox<T extends FieldValues>({
  name,
  label,
  labelBefore,
  isDisabled,
  value,
  parentSpanClassName,
  register,
}: CheckBoxProps<T>) {
  const registerResult = register(name, { disabled: isDisabled });
  const id = useId();

  return (
    <span className={(typeof parentSpanClassName === 'string') ? parentSpanClassName : 'ck-box'}>
      {labelBefore != null && (
        <span
          onClick={(e) => {
            document.getElementById(id)?.click();
            e.preventDefault();
          }}
          className="mr5 checkbox-label"
        >
          {labelBefore}
        </span>
      )}
      <input type="checkbox" id={id} {...registerResult} tabIndex={-1} value={value} disabled={isDisabled} />
      <label
        htmlFor={id}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={isDisabled ? undefined : 0}
        onKeyDown={(e) => {
          if (e.code === 'Space') {
            // TODO: document.getElementById を使わないようにする
            document.getElementById(id)?.click();
            e.preventDefault();
          }
        }}
      >
        &nbsp;
      </label>
      {label != null && (
        <span
          className="ml10 checkbox-label"
          onClick={(e) => {
            document.getElementById(id)?.click();
            e.preventDefault();
          }}
        >
          {label}
        </span>
      )}
    </span>
  );
}

CheckBox.defaultProps = {
  label: undefined,
  labelBefore: undefined,
  value: undefined,
  isDisabled: undefined,
  parentSpanClassName: undefined,
};
